module.exports = __webpack_public_path__ + "media/images/paisaje_1-e788c3d3.jpg";